import { useGoogleMap } from "@react-google-maps/api"
import CenterButton from "components/Organisms/map/CenterButton"
import { useLazyEffect } from "hooks/useLazyEffect"
import React, { useCallback } from "react"
import { useSearchParams } from "react-router-dom"
import useRouteStore from "../../routes.store"
import OutletMarker from "./OutletMarker"
import FinalRoutePolyline from "./PreviewRoutePolyline"

const OutletMapContent = ({ disabled = false }) => {
  const [params] = useSearchParams()
  const search = params.get("search")
  const outlets = useRouteStore(
    useCallback(store => store.querySelectedOutlets(search), [search])
  )
  const toggleSelect = useRouteStore(store => store.toggleOutletSelect)
  const step = useRouteStore(store => store.data.step)
  const routeId = useRouteStore(store => store.data.id)

  const allOutlets = useRouteStore(store => store.allOutlets())
  const markers = step === "select" ? allOutlets : outlets

  const map = useGoogleMap()

  function centerMap() {
    if (map && markers.length > 0) {
      const bounds = new window.google.maps.LatLngBounds()

      markers.forEach(l => {
        if (l.address) {
          bounds.extend({ lat: l.address.latitude, lng: l.address.longitude })
        }
      })
      map.fitBounds(bounds)
    }
  }

  // This will center the map only when the user stops selecting the outlets for 1.5 seconds,
  // this is done to ensure that the map does not change the zoom / bounds for every single outlet selected
  // as the user is in a zoomed-in position
  useLazyEffect(
    () => {
      centerMap()
    },
    [routeId, allOutlets],
    1500
  )
  if (!markers.length) return <></>
  return (
    <>
      <CenterButton onClick={centerMap} />
      {step === "order" && <FinalRoutePolyline />}
      {markers.map((marker, index) => {
        return (
          <OutletMarker
            disabled={disabled}
            marker={marker}
            index={index}
            toggleSelect={toggleSelect}
            step={step}
          />
        )
      })}
    </>
  )
}

export default OutletMapContent
